<ion-button (click)="toggleDownload($event)"
            shape="round"
            icon-only
            class="list-button"
            *ngIf="isButtonVisible"
            [ngClass]="delivery?.offlineStatus">
  <span class="icon state-download"></span>
</ion-button>
